import { v4 as uuidv4 } from 'uuid';

const AuthHeader = () => {

  const NewUuid = uuidv4()
  const AuthToken = localStorage.getItem("authToken");
  const Uuid = localStorage.getItem("device-uuid")
  const DeviceToken = localStorage.getItem("device-token")

  const headers = {
    Authorization: "",
    "device-uuid": "web1002",
    "device-token": "",
    "device-type": "web",
    "app-name": "webPanel",
  }

  if (Uuid) {
    headers["device-uuid"] = Uuid
  } else {
    localStorage.setItem("device-uuid", NewUuid)
  }

  if (AuthToken) headers.Authorization = "Bearer " + JSON.parse(AuthToken)
  if (DeviceToken) headers["device-token"] = DeviceToken

  return headers
}

export { AuthHeader }